// extracted by mini-css-extract-plugin
module.exports = {"apeironFormStyle":"_3URd85slGeIJia5KYpv6Cx"};